module.exports = "/_next/static/images/075f5992dc443aa4357b17a6e3f7ce44-sanpablo-5-desktop.jpg";